import React, { FC } from "react";
import { Grid, Typography } from "@mui/material";

interface Props {
  title: any;
  children?: any;
  actions?: React.ReactNode;
}

const PageLayout: FC<Props> = (props) => {
  const { title, children, actions } = props;
  return (
    <div className="panel">
      <div className="panel-container">
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <div className="panel-header">
              <Typography variant="h3">{title}</Typography>
            </div>
          </Grid>
          <Grid item xs="auto">
            <div className="panel-toolbar panel-toolbar-list">{actions}</div>
          </Grid>
        </Grid>
        <Grid item sx={{ marginTop: 4 }}>
          {children}
        </Grid>
      </div>
    </div>
  );
};

export default PageLayout;
